import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Box,
  TextField,
  Button,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { withTranslation } from "react-i18next";
import ApiUser from "../../../../../API/ApiUser";

const FeatureRequestDialog = ({ open, onClose, t }) => {
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleSubmit = async () => {
    if (!description.trim()) {
      setShowError(true);
      return;
    }

    setIsSubmitting(true);
    setShowError(false);

    try {
      const response = await ApiUser.submitFeatureRequest(description);

      if (response.status === 200 || response.status === 201) {
        setShowSuccess(true);
        setDescription("");
        setTimeout(() => {
          setShowSuccess(false);
          onClose();
        }, 2000);
      } else {
        setShowError(true);
      }
    } catch (error) {
      setShowError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setDescription("");
    setShowError(false);
    setShowSuccess(false);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "16px",
          backgroundColor: "#F8F9FA",
        },
      }}
    >
      <DialogContent style={{ padding: 0 }}>
        <Box position="relative">
          <IconButton
            onClick={handleClose}
            style={{
              position: "absolute",
              right: 8,
              top: 8,
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>

          <Box p={3}>
            <Typography
              variant="h5"
              gutterBottom
              style={{ fontWeight: 600, color: "#2A3142" }}
            >
              {t("feature_request_dialog.title")}
            </Typography>
            <Typography variant="body1" color="textSecondary" gutterBottom style={{ marginBottom: 24 }}>
              {t("feature_request_dialog.subtitle")}
            </Typography>

            <TextField
              multiline
              rows={6}
              fullWidth
              inputProps={{ maxLength: 5000 }}
              variant="outlined"
              placeholder={t("feature_request_dialog.placeholder")}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              style={{ marginBottom: 16 }}
            />

            {showError && (
              <Typography variant="body2" color="error" style={{ marginBottom: 16 }}>
                {t("feature_request_dialog.error")}
              </Typography>
            )}

            {showSuccess && (
              <Typography variant="body2" color="primary" style={{ marginBottom: 16 }}>
                {t("feature_request_dialog.success")}
              </Typography>
            )}

            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={isSubmitting || !description.trim()}
              style={{
                textTransform: "none",
                padding: "10px 24px",
              }}
            >
              {isSubmitting ? t("feature_request_dialog.submitting") : t("feature_request_dialog.submit")}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default withTranslation()(FeatureRequestDialog);

